import { render, staticRenderFns } from "./RelatoriosComponent.vue?vue&type=template&id=71924c4f"
import script from "./RelatoriosComponent.vue?vue&type=script&lang=js"
export * from "./RelatoriosComponent.vue?vue&type=script&lang=js"
import style0 from "./RelatoriosComponent.vue?vue&type=style&index=0&id=71924c4f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports